module.exports = __webpack_public_path__ + "media/landing/panelak2-35628a75.jpg";